const TerminologyExplorer = () => {
  return (
    <div className="head">
      <h2>TerminologyExplorer</h2>
    </div>

  );
}

export default TerminologyExplorer;